import { Pipe, PipeTransform } from "@angular/core";
import { ProjectDocuments, ProjectDocumentType } from "@handshake/core-types";

@Pipe({
  name: "filterDocuments",
})
export class FilterDocumentsPipe implements PipeTransform {
  transform(value: ProjectDocuments[], type: ProjectDocumentType): ProjectDocuments[] {
    return value?.filter((document) => document.type === type) ?? [];
  }
}
